import React, { useEffect, useState } from "react";
import { Bell, X, ArrowUpRight, ArrowDownRight } from "lucide-react";
import api from "../lib/api";

function timeAgo(dateStr) {
  const diff = (Date.now() - new Date(dateStr).getTime()) / 1000;
  if (diff < 60) return "gerade eben";
  if (diff < 3600) return `vor ${Math.floor(diff / 60)}min`;
  if (diff < 86400) return `vor ${Math.floor(diff / 3600)}h`;
  return `vor ${Math.floor(diff / 86400)}d`;
}

export default function AlertsPanel({ setups }) {
  const [alerts, setAlerts] = useState([]);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    api.listAlerts().then(data => setAlerts(data.slice(0, 5))).catch(() => {});
  }, [setups]);

  if (dismissed || alerts.length === 0) return null;

  return (
    <div className="border border-amber-500/30 bg-amber-500/5 rounded-sm">
      <div className="flex items-center justify-between px-4 py-2 border-b border-amber-500/20">
        <div className="flex items-center gap-2">
          <Bell size={13} className="text-amber-400" />
          <span className="font-display font-bold text-xs uppercase tracking-wider text-amber-300">
            Aktive Alerts ({alerts.length})
          </span>
        </div>
        <button
          onClick={() => setDismissed(true)}
          className="p-1 hover:bg-amber-500/10 rounded-sm text-zinc-500 hover:text-zinc-300"
        >
          <X size={12} />
        </button>
      </div>
      <div className="divide-y divide-amber-500/10">
        {alerts.map(a => {
          const setup = setups.find(s => s.id === a.setup_id);
          const isLong = setup?.direction === "long";
          const DirIcon = isLong ? ArrowUpRight : ArrowDownRight;
          return (
            <div key={a.id} className="px-4 py-2.5 flex items-center justify-between gap-3">
              <div className="flex items-center gap-2 min-w-0">
                {setup && (
                  <DirIcon
                    size={12}
                    className={isLong ? "text-emerald-500 shrink-0" : "text-rose-500 shrink-0"}
                    strokeWidth={2.5}
                  />
                )}
                <div className="min-w-0">
                  <span className="font-display font-bold text-xs text-zinc-200 truncate block">
                    {a.asset_name}
                  </span>
                  <span className="text-[10px] text-zinc-500 truncate block">{a.message}</span>
                </div>
              </div>
              <span className="text-[10px] text-zinc-600 font-mono-num shrink-0">
                {timeAgo(a.triggered_at)}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
